FoldersIndexNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNodeOptional"
    - $ref: "../parameters.yaml#/QueryLanguage"

  get:
    operationId: getFoldersIndexNode
    tags:
      - Folder
    summary: フォルダリストの照会
    description: |
      ### 指定フォルダ配下のフォルダリストを照会します。
      `node`はフォルダリストを照会する際に起点となるフォルダの識別コードです。
      - node が空白の場合は、最上位のフォルダを照会します。

      **My BOX**(「マイボックス」フォルダ)はユーザー自身の専用スペースです。本人以外は閲覧できません。

      **Shared BOX**(「共有」フォルダ)は同一会社内のユーザー間でファイルを共有するための領域です。 管理者により利用権限が与えられます。

    security:
      - AccessToken: [ ]

    responses:
      200:
        description: フォルダリスト照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/FolderList"
      "default":
        description: フォルダリスト照会失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"

FoldersIndexNodeDirSeq:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/PathDirSeq"
    - $ref: "../parameters.yaml#/QueryLanguage"

  get:
    operationId: getFoldersIndexNodeDirSeq
    tags:
      - Folder
    summary: フォルダの情報
    description: |
      ### 特定フォルダの情報照会
      
      `node` は情報照会対象のフォルダが存在する親フォルダの識別コードです。
      `dir_seq` はnode で指定したフォルダ直下にあるフォルダの識別コードです。

    security:
      - AccessToken: [ ]

    responses:
      "200":
        description: フォルダ情報照会成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/FolderInfo"
      "default":
        description: フォルダ情報照会失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Shared Box Is Disable:
                $ref: "../openapi/response.error.yaml#/SharedBoxIsDisable"

FoldersCreateNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: postFoldersCreateNode
    tags:
      - Folder
    summary: フォルダの追加
    description: |
      ### 指定フォルダ配下にフォルダを追加します。
      `node`は追加先フォルダの識別コードです。

      追加するフォルダと同名のフォルダが存在する場合はエラーが発生します。

      > 💡 &nbsp; **Note**  <br><br>
      **Shared BOX**では、管理者から作成権限が付与された場合のみ、第1階層のフォルダ(6文字以上)を作成可能です。
      第2階層以降のフォルダを作成するためにはOwner権限が必要です。

    security:
      - AccessToken: [ ]

    requestBody:
      $ref: "../openapi/requests.yaml#/CreateFolderRequest"

    responses:
      "200":
        description: フォルダ追加成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/CreateFolder"
      "default":
        description: フォルダ追加失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInputCreateFolder"
              Shared Box Is Disable:
                $ref: "../openapi/response.error.yaml#/SharedBoxIsDisable"
              Folder Name Length Exceeded:
                $ref: "../openapi/response.error.yaml#/FolderNameLengthExceeded"
              Folder Already Exist:
                $ref: "../openapi/response.error.yaml#/FolderAlreadyExist"

FoldersRenameNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: postFoldersRenameNode
    tags:
      - Folder
    summary: フォルダ名の変更
    description: |
      ### フォルダ名を変更します。
      `node`は名前変更対象フォルダの識別コードです。

      現在の場所に同じ名前のフォルダが存在する場合、エラーが発生します。

      > 💡 &nbsp; **Note**  <br><br>
      3文字以下のnodeはシステムで定義されたフォルダのnodeですので、変更対象にはできません。

    security:
      - AccessToken: [ ]

    requestBody:
      $ref: "../openapi/requests.yaml#/RenameFolderRequest"

    responses:
      "200":
        description: フォルダ名変更成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: フォルダ名変更失敗
        content:
          application/json:
            examples:
              Session Timeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Shared Box Is Disable:
                $ref: "../openapi/response.error.yaml#/SharedBoxIsDisable"
              Folder Name Length Exceeded:
                $ref: "../openapi/response.error.yaml#/FolderNameLengthExceeded"
              Folder Already Exist:
                $ref: "../openapi/response.error.yaml#/FolderAlreadyExist"

FoldersDeleteNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: postFoldersDeleteNode
    tags:
      - Folder
    summary: フォルダの削除
    description: |
      ### フォルダを削除します。
      `node`は削除対象フォルダの識別コードです。フォルダによっては削除が制限されることがあります。
      フォルダの階層によって削除が制限されることがあります。

      削除されたフォルダは、ユーザーのゴミ箱・管理者のゴミ箱の保存期間内であれば復元することができます。

      > 💡 &nbsp; **Note**  <br><br>
      **My Box** 3文字以下のnodeは削除不可 <br><br>
      **Shared Box** 6文字以下のnodeは削除不可  <br><br>
      **その他、対象フォルダ**にロックされているファイルが存在する場合は削除不可

    security:
      - AccessToken: [ ]

    responses:
      "200":
        description: フォルダ削除成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: フォルダ削除失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionfolderd"
              Delete Failed Included Lock File:
                $ref: "../openapi/response.error.yaml#/DeleteFailedIncludedLockFile"

FoldersMoveNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryLanguage"

  post:
    operationId: postFoldersMoveNode
    tags:
      - Folder
    summary: フォルダの移動
    description: |
      ### フォルダを移動します。
      `node`は移動対象フォルダが存在する親フォルダの識別コードです。

      nodes: {target node}|{destination node}

      `{target node}|{destination node}` の形式で指定します。
        - target node: 移動対象フォルダのノード
        - destination node: 移動先フォルダのノード

    security:
      - AccessToken: [ ]

    requestBody:
      $ref: "../openapi/requests.yaml#/MoveFolderRequest"

    responses:
      "200":
        description: フォルダ移動成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/Success"
      "default":
        description: フォルダ移動失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionfolderm"
              File Or Directory Not Exists:
                $ref: "../openapi/response.error.yaml#/FolderOrDirectoryNotExists"
              Same Directory Exists:
                $ref: "../openapi/response.error.yaml#/SameDirectoryExists"

FoldersQuotaNode:
  parameters:
    - $ref: "../parameters.yaml#/HeaderAccessToken"
    - $ref: "../parameters.yaml#/PathNode"
    - $ref: "../parameters.yaml#/QueryLanguage"

  get:
    operationId: getFoldersQuotaNode
    tags:
      - Folder
    summary: フォルダ容量情報の取得
    description: |
      ### フォルダの保存容量上限値（quota）と使用中容量を取得します。
      - My Boxの場合、ユーザーに割り当てた容量が保存容量上限値（quota）となります。
      - フォルダの保存容量上限値が未設定の場合は、上限値（quota）、使用中容量共に
        取得値は 0 となります。

    security:
      - AccessToken: [ ]

    responses:
      "200":
        description: フォルダ容量情報の取得成功
        content:
          application/json:
            schema:
              $ref: "../openapi/responses.yaml#/FoldersQuota"
      "default":
        description: フォルダ容量情報の取得失敗
        content:
          application/json:
            examples:
              SessionTimeout:
                $ref: "../openapi/response.error.yaml#/SessionTimeout"
              Invalid Input:
                $ref: "../openapi/response.error.yaml#/InvalidInput"
              File Or Directory Not Exists:
                $ref: "../openapi/response.error.yaml#/FolderOrDirectoryNotExists"
              Do Not Have Permission:
                $ref: "../openapi/response.error.yaml#/DoNotHavePermissionfolderi"